"use client"
import React, {FC, useEffect, useState} from 'react';
import {WidgetProps} from './component/widgetTitleBar';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Skeleton} from '@mui/material';
import {Row} from "@/core/general/row.component";
import VideoSwiperShortcutComponent from "@/core/widget/component/videoSwiperShortcut.component";
import {WidgetContainerComponent} from "@/core/general/ui/widgetContainer.component";
import {FreeMode} from "swiper/modules";
import {VideoGardiMainModel, VideoGardiModel} from "@/core/model/tmk.model";
import {WidgetVideoTitleBar} from "@/core/widget/component/widgetVideoTitleBar";

const MediaSwiperWidgetComponent: FC<WidgetProps> = (props) => {
  // const router = useRouter();
  const [videoList, setVideoList] = useState<VideoGardiModel[]>([]);

  useEffect(() => {
    if (props.widget.schema_data.source_url) {
        fetchData()
    }
  }, [props.widget]);

    const fetchData = async () => {
        let dr=await fetch(`${props.widget.schema_data.source_url}`,{
            method:"GET",
            cache: "default",
        })
        let dd:VideoGardiMainModel=await dr.json()
        setVideoList(dd.data?.results)
    };

  return (
    <WidgetContainerComponent className={"fullWidth"}>
        <WidgetVideoTitleBar widget={props.widget} hasTitle={props.hasTitle} type={"media"}/>
        {videoList?.length > 0 ? (
          <Row className="flex-nowrap overflow-scroll hideScrollBar">
            <Swiper slidesPerView={'auto'} freeMode={true} className={"!px-4"} modules={[FreeMode]}>
              {videoList?.map((item, index) => (
                <SwiperSlide style={{ width: 'auto' }} key={index} virtualIndex={index}>
                  <div className="w-auto p-1" key={index}>
                    <VideoSwiperShortcutComponent video={item} sourceUrl={props.widget.schema_data.source_url} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Row>
        ) : (
          <Row className="flex-nowrap overflow-scroll hideScrollBar">
            {[...Array(5)].map((i, index) => (
              <div key={index} className="w-auto p-2 mb-10">
                <Skeleton className="card card-box rounded videoBannerIconImage" variant="rectangular" />
              </div>
            ))}
          </Row>
        )}
    </WidgetContainerComponent>
  );
};

export default React.memo(MediaSwiperWidgetComponent);
